// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore"
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyDwNWBWPDgqB-f3iF7lP4obK5vnYqCGA3k",
  authDomain: "ivntalent-diagnosishub-m-461ca.firebaseapp.com",
  projectId: "ivntalent-diagnosishub-m-461ca",
  storageBucket: "ivntalent-diagnosishub-m-461ca.appspot.com",
  messagingSenderId: "429869483107",
  appId: "1:429869483107:web:36f40cd0a96e5e3335a456"
};

const app = initializeApp(firebaseConfig)
const db = getFirestore(app)

export default db;
